import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-devis',
  templateUrl: './devis.component.html',
  styleUrls: ['./devis.component.css']
})
export class DevisComponent implements OnInit {
  ngOnInit(): void {}
}
